import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import { Box, IconButton, SvgIcon } from '@mui/material';

import COLORS from 'theme/colors';
import { NO, YES } from './dropDownList';

export const EmergencyLabel = (props: any) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        Emergency Contact
        {props.SGEmergencyContactValue === NO && props.selectedTab === 2 && (
          <IconButton>
            <HealthAndSafetyOutlinedIcon fontSize='small' sx={{ color: COLORS.Error }} />
          </IconButton>
        )}
      </Box>
    </>
  );
};
export const SecoundaryLabel = (props: any) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        Secondary Guardian
        {props.SGEmergencyContactValue === YES && props.selectedTab === 1 && (
          <IconButton>
            <HealthAndSafetyOutlinedIcon sx={{ color: COLORS.Error }} fontSize='small' />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export const PrimaryLabel = (props: any) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        Primary Guardian
        {props.PGEmergecyContact === YES && props.selectedTab === 0 && (
          <IconButton>
            <HealthAndSafetyOutlinedIcon sx={{ color: COLORS.Error }} fontSize='small' />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export const CheckBoxBlankIcon = () => (
  <SvgIcon>
    <svg width='20' height='20' viewBox='0 0 24 24' fill='#fff' stroke='#b7bbbb' strokeWidth='1'>
      <rect x='2' y='2' width='16' height='16' rx='0' ry='0' stroke='#b7bbbb' fill='#fff' />
    </svg>
  </SvgIcon>
);

export const CheckBoxBlankIcon2 = () => (
  <SvgIcon>
    <svg width='20' height='20' viewBox='0 0 24 24' fill='#fff' stroke='#b7bbbb' strokeWidth='1'>
      <rect x='2' y='2' width='20' height='20' rx='0' ry='0' stroke='#b7bbbb' fill='#fff' />
    </svg>
  </SvgIcon>
);
